import { AnalyticsService } from 'src/app/shared/services/analytics/analytics.service';
import { take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthMethodsService } from './auth-methods.service';
import { UserDataService } from '../communication_services/userData.service';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { NutakuGi2 } from '../../plugins/nutaku-gi2';
import { NutakuGi2SigninData } from '../../types/nutaku-gi2.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthNutakuService {
  constructor(
    private _authMethodsService: AuthMethodsService,
    private _userDataService: UserDataService,
    private _platform: Platform,
    private _analyticsService: AnalyticsService,
  ) {}

  public auth() {
    // TODO Improve version checker.
    if (this._platform.is('hybrid')) {
      this._analyticsService.setNutakuVersion('APK');
    } else if (this._userDataService.nutakuDisplayVersion === 'pc') {
      this._analyticsService.setNutakuVersion('pc');
    } else {
      this._analyticsService.setNutakuVersion('sp');
    }

    if (Capacitor.isNativePlatform()) {
      this._onNativeLoginGi2();
    } else if ((window as any).GmnNutakuBridge?.auth) {
      this._onDirectBrowserLoginGi2();
    } else {
      this._onBrowserLoginGi2();
    }
  }

  private _onNativeLoginGi2() {
    NutakuGi2.addListener('auth', (event) => {
      if (event.isOk && event.data) {
        this._signWithNutakuGi2(event.data);
      } else {
        console.warn('Nutaku Android GI2 auth event failed', event.error);
      }
    });

    NutakuGi2.authenticate()
      .then((result) => {
        this._signWithNutakuGi2(result);
      })
      .catch((error) => {
        console.warn('Nutaku Android GI2 auth failed', error);
      });
  }

  private _signWithNutakuGi2(result: NutakuGi2SigninData) {
    this._authMethodsService
      .signWithNutakuGi2(result)
      .pipe(take(1))
      .subscribe();
  }

  private _onDirectBrowserLoginGi2() {
    (window as any).GmnNutakuBridge.auth()
      .then((result: NutakuGi2SigninData) => {
        this._signWithNutakuGi2(result);
      })
      .catch((error) => {
        console.warn('Nutaku GI2 auth failed', error);
      });
  }

  private _onBrowserLoginGi2() {
    window.parent.postMessage(
      JSON.stringify({ action: 'auth', height: window.innerHeight }),
      '*',
    );
    window.addEventListener(
      'message',
      (res) => {
        try {
          const result = JSON.parse(res?.data);
          if (result?.action === 'auth') {
            if (result.isOk && result.data) {
              this._authMethodsService
                .signWithNutakuGi2(result.data)
                .pipe(take(1))
                .subscribe();
            } else {
              console.warn('Nutaku GI2 auth failed', result?.error);
            }
          }
        } catch (error) {
          console.warn('Listener warn', error);
        }
      },
      false,
    );
  }
}
